import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from "../styles.pcss";
import { Button } from "../../../Button";
import { CloseIcon } from "../../../icons";
import { Label } from "../../../Label";
var cn = classNames.bind(styles);
var CoreInput = /*#__PURE__*/memo(function (_ref) {
  var disabled = _ref.disabled,
    label = _ref.label,
    leftAside = _ref.leftAside,
    rightAside = _ref.rightAside,
    className = _ref.className,
    type = _ref.type,
    onClear = _ref.onClear,
    inputRef = _ref.inputRef,
    inputProps = _ref.inputProps,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, leftAside && /*#__PURE__*/React.createElement("div", {
    className: cn('input__icon', 'input__icon--left'),
    "data-t-id": "Input-components"
  }, leftAside), /*#__PURE__*/React.createElement(Label, {
    disabled: disabled,
    id: inputProps === null || inputProps === void 0 ? void 0 : inputProps.id,
    label: label
  }, children || /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
    className: className,
    disabled: disabled,
    ref: inputRef,
    type: type
  }))), (rightAside || onClear) && /*#__PURE__*/React.createElement("div", {
    className: cn('input__icon', 'input__icon--right')
  }, onClear && inputProps !== null && inputProps !== void 0 && inputProps.value && !disabled && !inputProps.readOnly ? /*#__PURE__*/React.createElement("div", {
    className: cn('input__icon--clear')
  }, /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(CloseIcon, {
      size: 20
    }),
    onClick: onClear,
    variant: "plain"
  })) : rightAside));
});
export { CoreInput };